export interface IDashWorkFlowStatusRequest {
    // Core status fields
    statusId: number;
    centerNextFollowUpDate: string | null;
    reviewComments: string | null;
    remoteStatus: number | null;
    onHoldStatusReason: string | null;
    remoteStatusDate: string | null;
    
    // Rule-out specific fields (set to null as defaults)
    ruleOutReasonId: string | null;
    allowReRegistration: boolean | null;
    useNkrAssistance: boolean | null;
    coordinatorName: string | null;
    phoneNumber: string | null;
    medicalReasonCategory: number | null;
    medicalReasonNotes: string | null;
    
    // Request context fields (included in post body as requested)
    centerId: number;
    registrationId: number;

    applyForDonorShieldAdvancedReimbursement?: boolean | null;
    donorAlias?: string | null;
    advancedReimbursementDonorType?: number | null;
    ddRecipFirstName?: string | null;
    ddRecipLastName?: string | null;
    ddRecipDob?: string | null;
    recipientAlias?: string | null;
    linkedDonorShieldDirectId?: number | null;
    linkedDonorId?: number | null;
}
